var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useState } from 'react';
import useDesign from '../../../hooks/useDesign';
import { BaseButton } from '../../atoms/BaseButton';
import { GenericComponent } from '../../atoms/GenericComponent';
import { Icon } from '../../atoms/Icon';
import { ContentContainer } from '../../templates/ContentContainer';
import { ContentWrapper, RotatingIcon, StyledTranslatedText } from './styled';
export var Collapsible = function (_a) {
    var design = _a.design, values = _a.values, props = __rest(_a, ["design", "values"]);
    var _b = useDesign(design), components = _b.components, schema = _b.schema, config = _b.config;
    var initialOpen = Boolean(config === null || config === void 0 ? void 0 : config.open);
    var _c = useState(initialOpen), isOpen = _c[0], setIsOpen = _c[1];
    var accessibilityHeaderId = "".concat(design, "-header");
    var accessibilityContentId = "".concat(design, "-content");
    var toggleCollapse = function () { return setIsOpen(function (prev) { return !prev; }); };
    var allProps = __assign(__assign({}, props), { values: values });
    return (_jsxs(GenericComponent, __assign({ schema: schema, "data-design": design }, { children: [_jsxs(BaseButton, __assign({ design: components.toggleButton, onClick: toggleCollapse, "aria-expanded": isOpen, "aria-controls": accessibilityContentId, type: "button" }, { children: [_jsx(StyledTranslatedText, { id: accessibilityHeaderId, design: components.headerText }), (components === null || components === void 0 ? void 0 : components.headerContent) && (_jsx(ContentContainer, __assign({ design: components.headerContent }, { values: values }))), components.iconOpen && isOpen && _jsx(Icon, { design: components.iconClose }), components.iconClose && !isOpen && _jsx(Icon, { design: components.iconOpen }), !components.iconOpen && !components.iconClose && (_jsx(RotatingIcon, { src: "caret-down", rotated: isOpen, design: components.headerIndicator }))] })), _jsx(ContentWrapper, __assign({ role: "region", schema: schema.contentWrapper, id: accessibilityContentId, open: isOpen, "aria-hidden": !isOpen, "aria-labelledby": accessibilityHeaderId }, { children: _jsx(ContentContainer, __assign({ design: components.content }, allProps)) }))] })));
};
Collapsible.displayName = 'Collapsible';
export * from './Collapsible.types';
